export class FolderListExportEvent {
	public constructor() {}
}
